import { atom } from "jotai";

export const currentDurationOptionsAtom = atom<
  {
    courseId: string;
    endSlotOptions: {
      durationMins: number;
      allowedPlayerCounts: number[];
      slotId: string;
    }[];
  }[]
>([]);
